(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eg-application"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-eg-appli]');
    if (!root) return;
    var ua = navigator.userAgent || '';
    var ios = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var android = /Android/.test(ua);
    var installee = (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || navigator.standalone === true;
    var q = function (s) { return root.querySelector(s); };
    if (installee) q('[data-appli-ok]').hidden = false;
    /* Le bloc de l'appareil passe en premier ; les autres restent visibles (un lien ouvert sur ordinateur sert au téléphone). */
    var premier = ios ? q('[data-appli-ios]') : android ? q('[data-appli-android]') : null;
    if (premier) root.insertBefore(premier, q('[data-appli-android]'));
    if (ios || android) q('[data-appli-ordi]').hidden = true;
    var invite = null;
    var btn = q('[data-appli-installer]');
    window.addEventListener('beforeinstallprompt', function (e) {
      e.preventDefault();
      invite = e;
      btn.hidden = false;
    });
    btn.addEventListener('click', function () {
      if (!invite) return;
      invite.prompt();
      invite.userChoice.then(function () { invite = null; btn.hidden = true; });
    });
    window.addEventListener('appinstalled', function () { q('[data-appli-ok]').hidden = false; btn.hidden = true; });
    /* QR code vers cette page (bibliothèque QR de Shopify, déjà utilisée par l'impression des recettes). */
    var qr = q('[data-appli-qr]');
    var tracer = function () {
      if (!qr || qr.childNodes.length || typeof window.QRCode !== 'function') return;
      try { new window.QRCode(qr, { text: location.origin + location.pathname + location.search, width: 160, height: 160 }); } catch (e) { qr.hidden = true; }
    };
    if (document.readyState === 'complete') tracer(); else window.addEventListener('load', tracer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-artisan"]) return;
  try {
    
  /* Vitrine d'un artisan : onglets (motif ARIA tablist, flèches gauche/droite, Début/Fin) et pastilles de rayon
     (boutons à bascule, un seul actif). Sans JavaScript : blocs à la suite, toute la grille visible. */
  (function () {
    function onglets(root) {
      var bar = root.querySelector('[data-eg-art-tabs]');
      if (!bar) return;
      var tabs = Array.prototype.slice.call(bar.querySelectorAll('[data-tab]'));
      var pans = tabs.map(function (t) { return document.getElementById(t.getAttribute('data-tab')); });
      if (pans.some(function (p) { return !p; })) return;
      bar.setAttribute('role', 'tablist');
      if (bar.getAttribute('data-label')) bar.setAttribute('aria-label', bar.getAttribute('data-label'));
      root.classList.add('eg-art-tabbed');
      function choisir(i, focus) {
        tabs.forEach(function (t, j) {
          var on = i === j;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          pans[j].hidden = !on;
        });
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (t, i) {
        t.setAttribute('role', 'tab');
        t.setAttribute('aria-controls', pans[i].id);
        pans[i].setAttribute('role', 'tabpanel');
        pans[i].setAttribute('aria-labelledby', t.id);
        pans[i].tabIndex = 0;
        t.addEventListener('click', function () { choisir(i, false); });
        t.addEventListener('keydown', function (e) {
          var k = e.key; var n = tabs.length; var j = -1;
          if (k === 'ArrowRight') j = (i + 1) % n;
          else if (k === 'ArrowLeft') j = (i - 1 + n) % n;
          else if (k === 'Home') j = 0;
          else if (k === 'End') j = n - 1;
          if (j < 0) return;
          e.preventDefault();
          choisir(j, true);
        });
      });
      bar.hidden = false;
      choisir(0, false);
    }
    function rayons(root) {
      var box = root.querySelector('[data-eg-art-rayons]');
      if (!box) return;
      var chips = Array.prototype.slice.call(box.querySelectorAll('[data-r]'));
      var prods = Array.prototype.slice.call(root.querySelectorAll('.eg-art-p'));
      var live = root.querySelector('[data-eg-art-pnb]');
      box.hidden = false;
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          var r = c.getAttribute('data-r');
          chips.forEach(function (x) { x.setAttribute('aria-pressed', String(x === c)); });
          var n = 0;
          prods.forEach(function (p) { var ok = r === '' || p.getAttribute('data-r') === r; p.hidden = !ok; if (ok) n++; });
          if (live) live.textContent = (live.getAttribute(n === 1 ? 'data-one' : 'data-other') || '').replace(/\d+/, String(n));
        });
      });
    }
    function init(root) {
      if (!root || root.__egArtV) return;
      root.__egArtV = true;
      onglets(root);
      rayons(root);
    }
    function tout() { document.querySelectorAll('[data-eg-art-vit]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
    else tout();
    document.addEventListener('shopify:section:load', tout);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-artisans"] && !Shopify.designMode) return;
  try {
    
  /* Filtres de la page « Nos artisans » : une valeur au moins par groupe actif (OU dans un groupe, ET entre groupes).
     Pastilles = boutons à bascule (aria-pressed) ; nombre d'artisans affichés annoncé (aria-live). Sans JS : grille entière. */
  (function () {
    function init(root) {
      if (!root || root.__egArt) return;
      root.__egArt = true;
      var box = root.querySelector('[data-eg-art-flt]');
      var nb = root.querySelector('[data-eg-art-nb]');
      var vide = root.querySelector('[data-eg-art-aucun]');
      var cartes = Array.prototype.slice.call(root.querySelectorAll('.eg-art-c'));
      if (!box) return;
      var chips = Array.prototype.slice.call(box.querySelectorAll('[data-f]'));
      var raz = Array.prototype.slice.call(root.querySelectorAll('[data-eg-art-raz]'));
      box.hidden = false;
      function texte(n) {
        var t = nb.getAttribute(n === 1 ? 'data-one' : 'data-other') || '';
        return t.replace(/\d+/, String(n));
      }
      function maj() {
        var sel = {};
        chips.forEach(function (c) {
          if (c.getAttribute('aria-pressed') !== 'true') return;
          var g = c.getAttribute('data-f');
          (sel[g] = sel[g] || []).push(c.getAttribute('data-v'));
        });
        var actifs = Object.keys(sel).length > 0;
        var n = 0;
        cartes.forEach(function (a) {
          var ok = Object.keys(sel).every(function (g) {
            var v = a.getAttribute('data-f-' + g) || '';
            return sel[g].some(function (x) { return g === 'labels' ? v.indexOf('¦' + x + '¦') !== -1 : v === x; });
          });
          a.hidden = !ok;
          if (ok) n++;
        });
        nb.textContent = texte(n);
        if (vide) vide.hidden = n !== 0;
        raz.forEach(function (b) { if (!b.closest('[data-eg-art-aucun]')) b.hidden = !actifs; });
      }
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          maj();
        });
      });
      raz.forEach(function (b) {
        b.addEventListener('click', function () {
          chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          maj();
          if (chips[0]) chips[0].focus();
        });
      });
    }
    function tout() { document.querySelectorAll('[data-eg-art-page]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
    else tout();
    document.addEventListener('shopify:section:load', tout);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-cart"] && !Shopify.designMode) return;
  try {
    
  /* Panier : rechargement de la section par la Section Rendering API sur « eg:cart » (sans clignotement),
     note de commande enregistrée au fil de la saisie, « Enregistrer en favoris » (favoris maison, EG.favs). */
  (function () {
    if (window.__egCartSection) return;
    window.__egCartSection = true;
    var doc = document;
    var ctrl = null;

    function root() { return doc.querySelector('[data-eg-cart]'); }

    /* Repère l'élément qui a le focus pour le retrouver dans le nouveau rendu. */
    function focusKey(el) {
      var attrs = ['data-add', 'data-dec', 'data-eg-remove', 'data-empty', 'data-savelist', 'data-eg-note', 'id'];
      for (var i = 0; i < attrs.length; i++) if (el.hasAttribute(attrs[i])) return [attrs[i], el.getAttribute(attrs[i])];
      if (el.matches('.desk-only[data-checkout]')) return ['class', 'desk-only'];
      if (el.matches('.big[data-checkout]')) return ['class', 'big'];
      if (el.tagName === 'SUMMARY') return ['summary', ''];
      return null;
    }
    function findKey(r, k) {
      if (!k) return null;
      var f = null;
      if (k[0] === 'class') f = r.querySelector('[data-checkout].' + k[1]);
      else if (k[0] === 'summary') f = r.querySelector('.eg-note summary');
      else f = r.querySelector('[' + k[0] + '="' + (window.CSS && CSS.escape ? CSS.escape(k[1]) : k[1]) + '"]');
      /* Ligne passée de 1 à 0 : le bouton − disparaît ; on se replie sur + de la même variante, puis sur le titre. */
      if (!f && k[0] === 'data-dec') f = r.querySelector('[data-add="' + k[1] + '"]');
      return f || r.querySelector('.cart-hd h1');
    }

    function swap(oldRoot, newRoot) {
      /* Images déjà affichées : on garde les mêmes éléments (pas de rechargement visible). */
      var imgs = {};
      oldRoot.querySelectorAll('img').forEach(function (im) { var s = im.getAttribute('src'); if (s && !imgs[s]) imgs[s] = im; });
      newRoot.querySelectorAll('img').forEach(function (im) {
        var s = im.getAttribute('src'), o = imgs[s];
        if (o) { im.replaceWith(o); delete imgs[s]; }
      });
      /* Date de livraison déjà calculée par eg-delivery.js : on la reporte telle quelle. */
      var dOld = oldRoot.querySelector('[data-eg-delivery][data-eg-done]'), dNew = newRoot.querySelector('[data-eg-delivery]');
      if (dOld && dNew && !dNew.hasAttribute('data-eg-done')) { dNew.textContent = dOld.textContent; dNew.setAttribute('data-eg-done', ''); }
      /* Note en cours de saisie et état du dépliant. */
      var nOld = oldRoot.querySelector('[data-eg-note]'), nNew = newRoot.querySelector('[data-eg-note]');
      if (nOld && nNew) {
        nNew.value = nOld.value;
        var det = nNew.closest('details'), detOld = nOld.closest('details');
        if (det && detOld) det.open = detOld.open;
      }
      /* Option cadeau (16/10) : case, message en cours de saisie et dépliant gardés. */
      var cOld = oldRoot.querySelector('[data-eg-cadeau]'), cNew = newRoot.querySelector('[data-eg-cadeau]');
      if (cOld && cNew) cNew.checked = cOld.checked;
      var mOld = oldRoot.querySelector('[data-eg-cadeau-msg]'), mNew = newRoot.querySelector('[data-eg-cadeau-msg]');
      if (mOld && mNew) {
        mNew.value = mOld.value;
        var dc = mNew.closest('details'), dcOld = mOld.closest('details');
        if (dc && dcOld) dc.open = dcOld.open;
      }
      /* Case « 18 ans » (décision D6) : cochée avant le rechargement, elle le reste. */
      var aOld = oldRoot.querySelector('[data-eg-age-case]'), aNew = newRoot.querySelector('[data-eg-age-case]');
      if (aOld && aNew && aOld.checked) aNew.checked = true;
      var a = doc.activeElement, key = a && oldRoot.contains(a) ? focusKey(a) : null;
      var caret = key && key[0] === 'data-eg-note' ? [a.selectionStart, a.selectionEnd] : null;
      oldRoot.replaceWith(newRoot);
      /* Compteurs repeints avec les quantités connues d'eg-app.js (quantité maximale atteinte, clics en cours). */
      if (window.EG && typeof window.EG.paint === 'function') window.EG.paint(newRoot);
      revealSave(newRoot);
      announce(newRoot);
      if (key) {
        var f = findKey(newRoot, key);
        if (f) {
          f.focus({ preventScroll: true });
          if (caret) { try { f.setSelectionRange(caret[0], caret[1]); } catch (e) {} }
        }
      }
    }

    /* Région live stable (hors du nœud remplacé) : annonce le nouveau total, ou le panier vide. */
    function announce(r) {
      var live = doc.querySelector('[data-eg-cart-live]');
      if (!live) return;
      var tt = r.querySelector('.recap .tt'), em = r.querySelector('.empty b'), msg = '';
      /* Deux-points de la langue (clé eg.commun.deux_points : espace insécable avant en français seulement, audit C24). */
      if (tt) msg = Array.prototype.map.call(tt.children, function (c) { return c.textContent.trim(); }).join((live.getAttribute('data-sep') || ':') + ' ');
      else if (em) msg = em.textContent.trim();
      live.textContent = '';
      if (msg) setTimeout(function () { live.textContent = msg; }, 50);
    }

    function reload() {
      var r = root();
      if (!r) return;
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var id = r.getAttribute('data-section');
      /* 15/10 (eg-kitchen) : la tomate du logo se dessine sur le ticket pendant le rafraîchissement. */
      r.setAttribute('aria-busy', 'true');
      var url = (r.getAttribute('data-url') || '/cart') + '?sections=' + encodeURIComponent(id);
      /* Pas d'en-tête Accept: application/json : sur /cart, Shopify répondrait par le panier Ajax (cart.js)
         au lieu des sections demandées, et la page ne se mettrait jamais à jour. */
      fetch(url, { signal: ctrl ? ctrl.signal : undefined })
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
        .then(function (j) {
          var html = j && j[id];
          if (!html) return;
          /* Un clic a eu lieu pendant le rechargement : ce rendu est déjà périmé (le compteur sauterait en arrière,
             audit J11) ; le prochain « eg:cart », émis à la fin de ce clic, rechargera la section. */
          if (window.EG && typeof window.EG.busy === 'function' && window.EG.busy()) return;
          var t = doc.createElement('template');
          t.innerHTML = html;
          var fresh = t.content.querySelector('[data-eg-cart]');
          var cur = root();
          if (fresh && cur) swap(cur, fresh);
        })
        .then(function () { var c = root(); if (c) c.removeAttribute('aria-busy'); })
        .catch(function (e) { if (!e || e.name !== 'AbortError') location.reload(); });
    }
    doc.addEventListener('eg:cart', function () { if (root()) reload(); });

    /* Note de commande : enregistrée sans recharger la section (elle part aussi avec le formulaire).
       Saisie pas encore envoyée quand on quitte la page : envoyée tout de suite, en keepalive (audit J16). */
    var noteTimer = null, noteEl = null;
    function saveNote(keep) {
      clearTimeout(noteTimer);
      noteTimer = null;
      var n = noteEl;
      noteEl = null;
      if (!n) return;
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/update.js', {
        method: 'POST',
        keepalive: !!keep,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: n.value })
      }).catch(function () {});
    }
    doc.addEventListener('input', function (e) {
      var n = e.target.closest && e.target.closest('[data-eg-note]');
      if (!n) return;
      noteEl = n;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () { saveNote(false); }, 600);
    });
    /* Option cadeau (16/10) : attributs enregistrés sans recharger la section ; un message écrit coche la case. */
    var cdTimer = null, cdAttrs = null;
    function saveCadeau(keep) {
      clearTimeout(cdTimer);
      cdTimer = null;
      var at = cdAttrs;
      cdAttrs = null;
      if (!at) return Promise.resolve(false);
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return fetch(base + 'cart/update.js', {
        method: 'POST', keepalive: !!keep,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: at })
      }).then(function (r) { return r.ok; }).catch(function () { return false; });
    }
    doc.addEventListener('input', function (e) {
      var m = e.target.closest && e.target.closest('[data-eg-cadeau-msg]');
      if (!m) return;
      var c = m.closest('.eg-cadeau').querySelector('[data-eg-cadeau]');
      if (c && m.value.trim() && !c.checked) c.checked = true;
      cdAttrs = { 'Message cadeau': m.value.slice(0, 250), 'Cadeau': c && c.checked ? 'Oui' : '' };
      clearTimeout(cdTimer);
      cdTimer = setTimeout(function () { saveCadeau(false); }, 600);
    });
    doc.addEventListener('change', function (e) {
      var c = e.target.closest && e.target.closest('[data-eg-cadeau]');
      if (!c) return;
      cdAttrs = Object.assign(cdAttrs || {}, { 'Cadeau': c.checked ? 'Oui' : '' });
      saveCadeau(false).then(function (ok) {
        if (ok && window.EG && typeof window.EG.toast === 'function') window.EG.toast(c.getAttribute(c.checked ? 'data-l-oui' : 'data-l-non'));
      });
    });
    window.addEventListener('pagehide', function () { if (cdAttrs) saveCadeau(true); });
    window.addEventListener('pagehide', function () { if (noteEl) saveNote(true); });
    doc.addEventListener('visibilitychange', function () { if (doc.visibilityState === 'hidden' && noteEl) saveNote(true); });

    /* Favoris maison : le bouton n'apparaît qu'une fois EG.favs chargé (eg-app.js, module différé). */
    function revealSave(r) {
      var b = (r || doc).querySelector('[data-savelist]');
      if (b && window.EG && window.EG.favs) b.hidden = false;
    }
    revealSave();
    doc.addEventListener('DOMContentLoaded', function () { revealSave(); });

    /* Chaque produit du panier (une fois par produit) est ajouté aux favoris ; ceux déjà présents sont gardés.
       Liste pleine : arrêt et message, aucun favori n'est retiré. */
    function saveAll(btn) {
      var EG = window.EG;
      if (!EG || !EG.favs) return;
      btn.disabled = true;
      EG.get().then(function (c) {
        var seen = {}, full = false;
        (c.items || []).forEach(function (it) {
          if (full || !it.product_id || !it.handle || seen[it.product_id]) return;
          seen[it.product_id] = 1;
          if (EG.favs.has(it.product_id)) return;
          if (!EG.favs.add(it.product_id, it.handle)) full = true;
        });
        btn.disabled = false;
        EG.toast(btn.getAttribute(full ? 'data-max' : 'data-ok'), null, full);
      }).catch(function () { btn.disabled = false; EG.toast(btn.getAttribute('data-err'), null, true); });
    }
    /* Ligne devenue épuisée : retrait de la variante (quantité 0) par EG.setQty, dans la file d'attente du panier,
       qui relit les lignes si la clé a changé (remise appliquée entre-temps) : plus de clé périmée ni de rechargement
       de page (audit K2). Sans eg-app.js : retrait direct par la clé, puis rechargement. */
    doc.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-eg-remove]');
      if (!b) return;
      e.preventDefault();
      var EG = window.EG, base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var vid = b.getAttribute('data-eg-remove-v');
      b.disabled = true;
      if (EG && typeof EG.setQty === 'function' && vid) {
        EG.setQty(vid, 0).then(function () { EG.toast(b.getAttribute('data-ok')); }, function () {
          b.disabled = false;
          EG.toast(b.getAttribute('data-err'), null, true);
        });
        return;
      }
      fetch(base + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: b.getAttribute('data-eg-remove'), quantity: 0 })
      }).then(function (res) { if (!res.ok) throw new Error(res.status); })
        .then(function () { if (EG) { EG.toast(b.getAttribute('data-ok')); return EG.refresh(); } location.reload(); })
        .catch(function () { location.reload(); });
    });

    doc.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-savelist]');
      if (!b) return;
      e.preventDefault();
      saveAll(b);
    });

    /* Décision D6 : case « J'ai 18 ans ou plus » (panier avec alcool). En phase de capture, avant eg-app.js : tant qu'elle
       n'est pas cochée, aucun bouton de paiement ne part (message, case mise en vue et focus). Sans case : rien ne change. */
    doc.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-checkout]');
      if (!b) return;
      var r = root(), c = r && r.querySelector('[data-eg-age-case]');
      if (!c || c.checked) return;
      e.preventDefault();
      e.stopPropagation();
      var box = c.closest('[data-eg-age]'), err = box && box.querySelector('[data-eg-age-err]');
      if (box) box.classList.add('err');
      if (err) err.hidden = false;
      c.setAttribute('aria-invalid', 'true');
      if (box) box.scrollIntoView({ block: 'center', behavior: 'smooth' });
      c.focus({ preventScroll: true });
    }, true);
    doc.addEventListener('change', function (e) {
      var c = e.target;
      if (!c.matches || !c.matches('[data-eg-age-case]') || !c.checked) return;
      var box = c.closest('[data-eg-age]'), err = box && box.querySelector('[data-eg-age-err]');
      if (box) box.classList.remove('err');
      if (err) err.hidden = true;
      c.removeAttribute('aria-invalid');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-espace-client"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-eg-ec]');
    if (!root) return;
    root.classList.add('is-js');
    var views = Array.prototype.slice.call(root.querySelectorAll('[data-ec-view]'));
    var names = views.map(function (v) { return v.id; });
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-ec-link]'));
    var mq = window.matchMedia('(min-width: 900px)');

    function current() {
      var h = '';
      try { h = decodeURIComponent(location.hash.slice(1)); } catch (e) { h = ''; }
      if (names.indexOf(h) > -1) return h;
      return mq.matches ? names[0] : '';
    }
    function apply(move) {
      var v = current();
      views.forEach(function (x) { x.classList.toggle('is-on', x.id === v); });
      if (v) root.setAttribute('data-view', v); else root.removeAttribute('data-view');
      links.forEach(function (a) {
        if (a.getAttribute('data-ec-link') === v) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
      if (!move) return;
      var target = v ? document.getElementById('ec-h-' + v) : root.querySelector('.eg-ec-hd h1');
      var top = root.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo(0, Math.max(0, top));
      if (target) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
    }
    window.addEventListener('hashchange', function () { apply(true); });
    if (mq.addEventListener) mq.addEventListener('change', function () { apply(false); });
    else if (mq.addListener) mq.addListener(function () { apply(false); });
    apply(false);

    /* Commander à nouveau : tout d'un coup. Si Shopify refuse (stock, réseau), on relit le panier et on ne
       rejoue, article par article, que les variantes dont la quantité n'a pas bougé (jamais de double ajout). */
    function say(msg, err) {
      if (window.EG && typeof window.EG.toast === 'function') window.EG.toast(msg, null, !!err);
    }
    function done(n, partial) {
      var msg = n === 1 ? root.getAttribute('data-t-ok-1') : root.getAttribute('data-t-ok-n').replace('__N__', n);
      if (partial) msg += ' ' + root.getAttribute('data-t-partiel');
      say(msg);
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ec-reorder]');
      if (!b || b.disabled) return;
      e.preventDefault();
      var EG = window.EG;
      var raw = [];
      try { raw = JSON.parse(b.getAttribute('data-ec-reorder')) || []; } catch (err) { raw = []; }
      var want = {};
      raw.forEach(function (i) {
        var id = String(i && i.id || '');
        var q = Math.floor(Number(i && i.quantity)) || 0;
        if (id && q > 0) want[id] = (want[id] || 0) + q;
      });
      var ids = Object.keys(want);
      if (!ids.length || !EG || typeof EG.addMany !== 'function' || typeof EG.qty !== 'function' || typeof EG.refresh !== 'function') { say(root.getAttribute('data-t-err'), true); return; }
      var items = ids.map(function (id) { return { id: Number(id), quantity: want[id] }; });
      var ko = Number(b.getAttribute('data-ko')) || 0;
      var total = ids.reduce(function (s, id) { return s + want[id]; }, 0);
      var before = {};
      b.disabled = true;
      b.setAttribute('aria-busy', 'true');
      var ready = typeof EG.get === 'function' ? EG.get() : EG.refresh();
      ready
        .then(function () {
          ids.forEach(function (id) { before[id] = EG.qty(id); });
          return EG.addMany(items).then(function () { done(total, ko > 0); }, function () {
            /* Panier relu : sans lecture fiable, on s'arrête plutôt que de risquer un doublon. */
            return EG.refresh().then(function () {
              var ok = 0;
              var chain = Promise.resolve();
              ids.forEach(function (id) {
                var got = Math.max(0, EG.qty(id) - before[id]);
                if (got > 0) { ok += Math.min(got, want[id]); return; }
                chain = chain.then(function () {
                  return EG.addMany([{ id: Number(id), quantity: want[id] }]).then(function () { ok += want[id]; }, function () {});
                });
              });
              return chain.then(function () {
                if (ok) done(ok, true); else say(root.getAttribute('data-t-err'), true);
              });
            });
          });
        })
        .catch(function () { say(root.getAttribute('data-t-err'), true); })
        .then(function () { b.disabled = false; b.removeAttribute('aria-busy'); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-footer"]) return;
  try {
    
  /* « Gérer les cookies » (audit du 9/10, C9) : affiché seulement si la bannière de cookies de Shopify est chargée. */
  (function () {
    if (window.__egCk) return;
    window.__egCk = true;
    function ok() { return !!(window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function'); }
    function paint() { document.querySelectorAll('[data-eg-cookies]').forEach(function (li) { li.hidden = !ok(); }); }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-eg-cookies] button');
      if (!b || !ok()) return;
      e.preventDefault();
      window.privacyBanner.showPreferences();
    });
    /* La bannière se charge après la page : nouvel essai quelques secondes plus tard. */
    function start() { paint(); setTimeout(paint, 2500); }
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start);
    document.addEventListener('shopify:section:load', paint);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-header"]) return;
  try {
    
  /* En-tête ordinateur (chantier G-bureau) :
     - panneau des rayons : bouton [data-eg-mega]. Le panneau est rendu après l'en-tête : au clavier, Tab depuis le bouton
       ouvert entre dans le panneau (ouverture au clavier : focus sur le premier rayon), Maj+Tab depuis le premier lien revient
       au bouton, Tab depuis le dernier lien ferme le panneau et va à l'entrée suivante de l'en-tête (Recettes).
       Échap, clic à l'extérieur ou focus ailleurs le ferment ; le focus revient au bouton s'il était dans le panneau ;
     - nombre de favoris : badge [data-fav-count], tenu à jour par eg-app.js (paintFav), comme la pastille de l'onglet ;
     - flèches des carrousels [data-eg-rail] : balisées par les sections d'accueil, ajoutées depuis #EgArrTpl aux autres
       carrousels .sec > .rail (fiche, habituels…) ; défilement d'environ une largeur, état aux extrémités. */
  (function () {
    if (window.__egBureau) return;
    window.__egBureau = true;
    var d = document;
    var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function mega(open) {
      var b = d.getElementById('EgMegaBtn');
      var p = d.getElementById('EgMega');
      if (!b || !p) return;
      var was = b.getAttribute('aria-expanded') === 'true';
      if (open === undefined) open = !was;
      b.setAttribute('aria-expanded', String(open));
      p.hidden = !open;
      if (!open && was && p.contains(d.activeElement)) b.focus();
    }
    function megaLinks() {
      var p = d.getElementById('EgMega');
      return p ? Array.prototype.slice.call(p.querySelectorAll('a[href]')) : [];
    }
    /* Entrée de l'en-tête qui suit le bouton Rayons (ordre de tabulation). */
    function afterBtn(b) {
      var hd = d.getElementById('hd');
      if (!hd) return null;
      var all = Array.prototype.slice.call(hd.querySelectorAll('a[href], button:not([disabled])')).filter(function (x) { return x.offsetParent !== null; });
      var i = all.indexOf(b);
      return i >= 0 ? all[i + 1] || null : null;
    }
    d.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      if (t.closest('[data-eg-mega]')) {
        mega();
        /* Ouverture au clavier (Entrée, Espace : e.detail vaut 0) : focus sur le premier rayon. */
        var b0 = d.getElementById('EgMegaBtn');
        if (e.detail === 0 && b0 && b0.getAttribute('aria-expanded') === 'true') { var l0 = megaLinks()[0]; if (l0) l0.focus(); }
        return;
      }
      var p = d.getElementById('EgMega');
      if (p && !p.hidden && !p.contains(t)) mega(false);
      var a = t.closest('[data-eg-rail]');
      if (a) {
        var r = d.getElementById(a.getAttribute('aria-controls'));
        if (!r || a.getAttribute('aria-disabled') === 'true') return;
        var dir = a.getAttribute('data-eg-rail') === 'prev' ? -1 : 1;
        r.scrollBy({ left: dir * Math.max(160, r.clientWidth * 0.85), behavior: REDUCE ? 'auto' : 'smooth' });
      }
    });
    d.addEventListener('keydown', function (e) {
      var p = d.getElementById('EgMega');
      var b = d.getElementById('EgMegaBtn');
      if (!p || !b || p.hidden) return;
      if (e.key === 'Escape') { mega(false); b.focus(); return; }
      if (e.key !== 'Tab') return;
      var links = megaLinks();
      if (!links.length) return;
      var a = d.activeElement;
      if (!e.shiftKey && a === b) { e.preventDefault(); links[0].focus(); }
      else if (e.shiftKey && a === links[0]) { e.preventDefault(); b.focus(); }
      else if (!e.shiftKey && a === links[links.length - 1]) {
        var nx = afterBtn(b);
        if (nx) { e.preventDefault(); mega(false); nx.focus(); }
      }
    });
    d.addEventListener('focusin', function (e) {
      var p = d.getElementById('EgMega');
      var b = d.getElementById('EgMegaBtn');
      if (p && !p.hidden && !p.contains(e.target) && e.target !== b) mega(false);
    });

    /* Flèches des carrousels */
    function railState(r) {
      var id = r.id;
      if (!id) return;
      var btns = d.querySelectorAll('[data-eg-rail][aria-controls="' + id + '"]');
      if (!btns.length) return;
      var max = r.scrollWidth - r.clientWidth;
      var wrap = btns[0].parentNode;
      wrap.hidden = max <= 2;
      btns.forEach(function (b) {
        var off = b.getAttribute('data-eg-rail') === 'prev' ? r.scrollLeft <= 2 : r.scrollLeft >= max - 2;
        b.setAttribute('aria-disabled', String(off));
      });
    }
    var railN = 0;
    function railArrows() {
      var tpl = d.getElementById('EgArrTpl');
      if (!tpl || !tpl.content) return;
      d.querySelectorAll('.sec > .rail:not([data-eg-arrows])').forEach(function (r) {
        var sec = r.parentNode;
        var h = sec.querySelector(':scope > h2, :scope > .eg-sec-hd > h2');
        if (!h) return;
        if (!r.id) r.id = 'EgRailX' + (++railN);
        var w = tpl.content.firstElementChild.cloneNode(true);
        w.querySelectorAll('[data-eg-rail]').forEach(function (x) { x.setAttribute('aria-controls', r.id); });
        sec.classList.add('eg-arr-sec');
        sec.insertBefore(w, r);
        r.setAttribute('data-eg-arrows', '');
        /* Carrousel rempli après coup (« Vus récemment ») : état recalculé quand son contenu change. */
        if ('MutationObserver' in window) new MutationObserver(function () { railState(r); }).observe(r, { childList: true });
        if ('ResizeObserver' in window) new ResizeObserver(function () { railState(r); }).observe(r);
      });
    }
    function railsAll() { railArrows(); d.querySelectorAll('.rail[data-eg-arrows]').forEach(railState); }
    var raf = 0;
    d.addEventListener('scroll', function (e) {
      var r = e.target;
      if (!r.matches || !r.matches('.rail[data-eg-arrows]') || raf) return;
      raf = requestAnimationFrame(function () { raf = 0; railState(r); });
    }, { capture: true, passive: true });
    window.addEventListener('resize', function () { railsAll(); if (window.innerWidth < 900) mega(false); }, { passive: true });
    window.addEventListener('load', railsAll);
    d.addEventListener('shopify:section:load', railsAll);
    function start() { railsAll(); }
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-page-compte"]) return;
  try {
    
  (function () {
    /* Pays et régions des formulaires d'adresse : options de all_country_option_tags (data-provinces). */
    function provinces(country) {
      var form = country.form;
      var prov = form && form.querySelector('[data-eg-province]');
      var wrap = form && form.querySelector('[data-eg-province-wrap]');
      if (!prov || !wrap) return;
      var opt = country.options[country.selectedIndex];
      var list = [];
      try { list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (e) { list = []; }
      var keep = prov.value || prov.getAttribute('data-default') || '';
      prov.innerHTML = '';
      list.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p[0];
        o.textContent = p[1];
        if (p[0] === keep || p[1] === keep) o.selected = true;
        prov.appendChild(o);
      });
      wrap.hidden = list.length === 0;
    }
    function init() {
      document.querySelectorAll('[data-eg-country]').forEach(function (c) {
        var d = c.getAttribute('data-default');
        if (d) {
          for (var i = 0; i < c.options.length; i++) {
            if (c.options[i].value === d || c.options[i].textContent === d) { c.selectedIndex = i; break; }
          }
        }
        provinces(c);
        c.addEventListener('change', function () { var p = c.form && c.form.querySelector('[data-eg-province]'); if (p) p.value = ''; provinces(c); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    /* « Annuler » du volet mot de passe oublié : retour à la connexion, même après un envoi (classe is-recover). */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.eg-acc a[href="#login"]');
      if (!a) return;
      var acc = a.closest('.eg-acc');
      if (acc) acc.classList.remove('is-recover');
    });

    /* Suppression d'une adresse : POST _method=delete vers address.url, après confirmation. */
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-eg-addr-del]');
      if (!b) return;
      if (!window.confirm(b.getAttribute('data-confirm'))) return;
      var f = document.createElement('form');
      f.method = 'post';
      f.action = b.getAttribute('data-eg-addr-del');
      var m = document.createElement('input');
      m.type = 'hidden';
      m.name = '_method';
      m.value = 'delete';
      f.appendChild(m);
      document.body.appendChild(f);
      f.submit();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-page-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fill() {
      var body = document.getElementById('EgContactBody');
      if (!body || body.value.trim() !== '') return;
      var q = new URLSearchParams(window.location.search);
      var produit = (q.get('produit') || '').slice(0, 200).trim();
      var sujet = (q.get('sujet') || '').slice(0, 200).trim();
      var lines = [];
      if (produit) lines.push(String(body.getAttribute('data-p-produit')).replace('__X__', produit));
      if (sujet) lines.push(String(body.getAttribute('data-p-sujet')).replace('__X__', sujet));
      if (lines.length) body.value = lines.join('\n') + '\n\n';
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill);
    else fill();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-product"] && !Shopify.designMode) return;
  try {
    
  /* « Commander en nombre » (16/10) : ajoute la quantité tapée en une fois (EG.add), message avec lien vers le panier. */
  (function () {
    if (window.__egNb) return;
    window.__egNb = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-nb-ajout]');
      if (!b || b.getAttribute('aria-busy') === 'true') return;
      var E = window.EG;
      var zone = b.closest('.eg-nb-in');
      var inp = zone && zone.querySelector('[data-nb-q]');
      if (!E || !inp) return;
      var max = Number(b.getAttribute('data-nb-max')) || 999;
      var n = Math.floor(Number(inp.value));
      if (!(n >= 1) || n > max) {
        E.toast((b.getAttribute('data-l-max') || '').replace('__MAX__', String(max)), null, true);
        inp.focus();
        return;
      }
      b.setAttribute('aria-busy', 'true');
      b.disabled = true;
      var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      E.add(b.getAttribute('data-nb-ajout'), n).then(function () {
        E.toast((b.getAttribute('data-l-ok') || '').replace('__N__', String(n)), null, false, 0, { href: racine + 'cart', label: b.getAttribute('data-l-panier') || '' });
      }, function () {
        E.toast((b.getAttribute('data-l-max') || '').replace('__MAX__', String(max)), null, true);
      }).then(function () { b.removeAttribute('aria-busy'); b.disabled = false; });
    });
  })();

  /* « Parfait avec » (16/10, décomposition REA d'Amazon, « souvent achetés ensemble ») : une case par produit associé ;
     le bouton « Ajouter les n · total » suit les cases (identifiants data-trio, nombre, total) ; le produit de la fiche
     reste toujours inclus. Bouton rechargé avec la variante ([data-eg-live]) : recalé sur les cases. */
  (function () {
    function sync(sec) {
      var b = sec.querySelector('[data-trio][data-base]');
      if (!b) return;
      var ids = [b.getAttribute('data-base')];
      var tot = Number(b.getAttribute('data-base-prix')) || 0;
      sec.querySelectorAll('[data-trio-cb]').forEach(function (c) {
        if (c.checked && !c.disabled) { ids.push(c.value); tot += Number(c.getAttribute('data-prix')) || 0; }
      });
      b.setAttribute('data-trio', ids.join(','));
      var m = window.EG && typeof window.EG.money === 'function' ? window.EG.money(tot) : (tot / 100).toFixed(2).replace('.', ',') + ' €';
      var tpl = b.getAttribute('data-l-trio') || '';
      if (tpl) b.textContent = tpl.replace('__N__', String(ids.length)).replace('__M__', m);
      b.hidden = ids.length < 2;
    }
    function init() {
      document.querySelectorAll('section.pairs').forEach(function (sec) {
        if (sec.__egTrio) return;
        sec.__egTrio = true;
        sec.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[data-trio-cb]')) sync(sec); });
        if ('MutationObserver' in window) {
          new MutationObserver(function () {
            var b = sec.querySelector('[data-trio][data-base]');
            if (b && !b.__egSync) { b.__egSync = true; sync(sec); }
          }).observe(sec, { childList: true, subtree: true });
        }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  /* Fiche produit (chantier P) :
     - pastilles de variantes : rechargement par la Section Rendering API des éléments [data-eg-live], adresse ?variant=, image de la variante ;
     - galerie : flèches précédent / suivant et défilement au clavier (fonction gallery) ;
     - après « eg:cart » : jauge, message de livraison offerte et second bouton de l'encadré d'achat ;
     - « Vus récemment » (section eg-product-suite) : localStorage (eg-vus), cartes rendues par la section eg-product-carte ;
     - « Donner mon avis » : ouvre le formulaire Judge.me s'il est présent ;
     - suivi Klaviyo « Added to Cart » (repris de l'ancien thème), seulement si Klaviyo est chargé et si le visiteur a
       accepté le marketing (Shopify.customerPrivacy.marketingAllowed()). */
  (function () {
    var KEY = 'eg-vus';
    var VAR_KEYS = ['price', 'badges', 'vars', 'stock', 'ship', 'gauge', 'abo', 'actions', 'trio', 'about', 'specs', 'pbar', 'kl'];
    var CART_KEYS = ['ship', 'gauge', 'bb2'];
    var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function rootUrl() {
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return r.charAt(r.length - 1) === '/' ? r : r + '/';
    }
    function readVus() {
      try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v.filter(function (x) { return typeof x === 'string' && x; }) : []; } catch (e) { return []; }
    }
    function writeVus(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* stockage indisponible */ } }
    function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
    /* Consentement marketing (API Customer Privacy de Shopify) : faux si l'API est absente ou en erreur. */
    function marketingOk() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      try { return !!(cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed()); } catch (e) { return false; }
    }
    /* Charge l'API si la page ne l'a pas déjà (bannière de cookies absente) ; une seule fois, sur la fiche seulement. */
    function loadPrivacy() {
      if (window.__egCp || !window.Shopify || window.Shopify.customerPrivacy || typeof window.Shopify.loadFeatures !== 'function') return;
      window.__egCp = true;
      try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {}); } catch (e) { /* API indisponible : aucun suivi */ }
    }

    function init(root) {
      if (!root || root.hasAttribute('data-eg-ready')) return;
      root.setAttribute('data-eg-ready', '');
      loadPrivacy();
      var sid = root.getAttribute('data-section');
      var handle = root.getAttribute('data-handle');
      var varCtrl = null;
      var cartCtrl = null;
      var cartTimer = 0;

      function sectionUrl(vid) {
        return location.pathname + '?variant=' + encodeURIComponent(vid) + '&section_id=' + encodeURIComponent(sid);
      }
      function fetchDoc(vid, ctrl) {
        return fetch(sectionUrl(vid), { signal: ctrl.signal, headers: { Accept: 'text/html' } }).then(function (r) {
          if (!r.ok) throw new Error(String(r.status));
          return r.text();
        }).then(parse);
      }
      function swap(d, keys) {
        keys.forEach(function (k) {
          var fresh = d.querySelector('[data-eg-live="' + k + '"]');
          root.querySelectorAll('[data-eg-live="' + k + '"]').forEach(function (old) {
            if (fresh) old.replaceWith(document.importNode(fresh, true));
            else old.remove();
          });
        });
        /* Bouton de paiement express rechargé avec la variante : Shopify le réinitialise. */
        if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') window.Shopify.PaymentButton.init();
      }
      function showMedia(id) {
        if (!id) return;
        var track = root.querySelector('.gal-track');
        var slide = track && track.querySelector('[data-media-id="' + id + '"]');
        if (!slide) return;
        var i = Array.prototype.indexOf.call(track.children, slide);
        track.scrollTo({ left: i * track.clientWidth, behavior: REDUCE ? 'auto' : 'smooth' });
      }

      function chooseVariant(btn) {
        var vid = btn.getAttribute('data-eg-variant');
        var pos = btn.getAttribute('data-eg-pos');
        if (varCtrl) varCtrl.abort();
        varCtrl = new AbortController();
        /* Relecture du panier en attente ou en cours : elle viserait l'ancienne variante (J12). */
        clearTimeout(cartTimer);
        if (cartCtrl) cartCtrl.abort();
        root.setAttribute('aria-busy', 'true');
        fetchDoc(vid, varCtrl).then(function (d) {
          swap(d, VAR_KEYS);
          var nr = d.querySelector('[data-eg-product]');
          var nv = (nr && nr.getAttribute('data-variant')) || vid;
          root.setAttribute('data-variant', nv);
          abo(root, false);
          root.querySelectorAll('.gal-heart [data-fav-variant]').forEach(function (h) { h.setAttribute('data-fav-variant', nv); });
          var u = new URL(location.href);
          u.searchParams.set('variant', nv);
          history.replaceState(history.state, '', u.toString());
          var vars = root.querySelector('[data-eg-live="vars"]');
          if (vars) showMedia(vars.getAttribute('data-eg-media'));
          var f = root.querySelector('[data-eg-pos="' + pos + '"]');
          if (f) f.focus({ preventScroll: true });
          /* Audit du 9/10 (X6) : prix et disponibilité de la variante choisie lus par les lecteurs d'écran. */
          var live = root.querySelector('[data-eg-var-live]');
          if (live) {
            var parts = [];
            ['.price-line', '.bb-stock'].forEach(function (s) { var el = root.querySelector(s); if (el) parts.push(el.textContent.replace(/\s+/g, ' ').trim()); });
            live.textContent = parts.filter(Boolean).join('. ');
          }
        }).catch(function (e) {
          if (e && e.name === 'AbortError') return;
          location.href = location.pathname + '?variant=' + encodeURIComponent(vid);
        }).then(function () { root.removeAttribute('aria-busy'); });
      }

      function onCart() {
        if (!root.isConnected) { document.removeEventListener('eg:cart', onCart); return; }
        clearTimeout(cartTimer);
        cartTimer = setTimeout(function () {
          if (cartCtrl) cartCtrl.abort();
          cartCtrl = new AbortController();
          var asked = root.getAttribute('data-variant');
          fetchDoc(asked, cartCtrl).then(function (d) {
            /* Variante changée pendant la relecture : ce rendu est celui de l'ancienne variante (audit du 9/10, J12) ;
               on relit pour la nouvelle (sa page a pu être rendue avant la mise à jour du panier). */
            if (root.getAttribute('data-variant') !== asked) { onCart(); return; }
            swap(d, CART_KEYS);
          }).catch(function () { /* l'état serveur reviendra au prochain chargement */ });
        }, 120);
      }
      document.addEventListener('eg:cart', onCart);

      function track(t) {
        var q = window._learnq;
        if (!q || typeof q.push !== 'function') return;
        /* Audit du 9/10 (C9, S10) : rien n'est envoyé à Klaviyo sans consentement marketing connu. */
        if (!marketingOk()) return;
        var vid = root.getAttribute('data-variant');
        var hit = t.matches('[data-buynow]') || (t.matches('[data-add]') && t.getAttribute('data-add') === vid && !t.closest('.step'));
        if (!hit) return;
        var data = root.querySelector('script[data-eg-kl]');
        if (!data) return;
        try {
          var p = JSON.parse(data.textContent);
          q.push(['track', 'Added to Cart', {
            AddedItemProductName: p.ProductName, AddedItemProductID: String(p.ProductID), AddedItemSKU: p.SKU,
            AddedItemCategories: p.Categories, AddedItemURL: p.URL, AddedItemBrand: p.Brand, AddedItemImageURL: p.ImageURL, $value: p.Price
          }]);
        } catch (e) { /* données absentes */ }
      }

      root.addEventListener('click', function (e) {
        var v = e.target.closest('[data-eg-variant]');
        if (v && root.contains(v)) {
          e.preventDefault();
          if (v.getAttribute('aria-pressed') !== 'true') chooseVariant(v);
          return;
        }
        var a = e.target.closest('[data-add],[data-buynow]');
        if (a && root.contains(a)) track(a);
      });
      root.addEventListener('change', function (e) {
        if (e.target.matches && e.target.matches('input[data-eg-abo-r]') && root.contains(e.target)) abo(root, true);
      });

      gallery(root);
      abo(root, false);
    }

    /* Achat unique ou abonnement (snippet eg-abo, préparation du 16/10) : sans [data-eg-abo] (aucun plan de vente),
       rien ne change. Le plan choisi est posé sur la racine : data-eg-abo-plan (identifiant du plan) et data-eg-abo-v
       (variante à laquelle il s'applique) ; eg-app.js l'ajoute (selling_plan) aux ajouts de cette variante seulement
       (encadré d'achat, barre fixe, « Ajouter et voir le panier », trio), jamais à un autre produit de la page.
       Barre fixe : prix et nom du plan choisi. Changement de variante : le même plan est repris s'il existe pour la
       nouvelle variante, sinon le premier plan (abonnement gardé), sinon « Achat unique ». annoncer : choix lu aux
       lecteurs d'écran (région polie [data-eg-var-live]). */
    function abo(root, annoncer) {
      var box = root.querySelector('[data-eg-abo]');
      var radios = box && !box.hidden ? Array.prototype.slice.call(box.querySelectorAll('input[data-eg-abo-r]')) : [];
      var prev = root.__egAbo;
      if (!annoncer && prev && radios.length) {
        var hit = radios.filter(function (r) { return r.value === prev; })[0];
        if (!hit && prev !== '') hit = radios.filter(function (r) { return r.value !== ''; })[0];
        if (!hit) hit = radios.filter(function (r) { return r.value === ''; })[0];
        if (hit) hit.checked = true;
      }
      var cur = radios.filter(function (r) { return r.checked; })[0] || null;
      var plan = cur && /^[1-9]\d{0,15}$/.test(cur.value) ? cur.value : '';
      if (cur) root.__egAbo = plan;
      if (plan) {
        root.setAttribute('data-eg-abo-plan', plan);
        root.setAttribute('data-eg-abo-v', box.getAttribute('data-v') || root.getAttribute('data-variant') || '');
      } else {
        root.removeAttribute('data-eg-abo-plan');
        root.removeAttribute('data-eg-abo-v');
      }
      var pr = root.querySelector('#pbar [data-eg-abo-pbar]');
      if (pr) {
        var sm = pr.querySelector('small');
        if (!pr.__egAboU) {
          var t0 = '';
          for (var n = pr.firstChild; n && n !== sm; n = n.nextSibling) t0 += n.textContent;
          pr.__egAboU = { prix: t0, small: sm ? sm.textContent : '' };
        }
        var u = pr.__egAboU;
        while (pr.firstChild && pr.firstChild !== sm) pr.removeChild(pr.firstChild);
        pr.insertBefore(document.createTextNode(plan ? cur.getAttribute('data-prix') || u.prix : u.prix), sm || null);
        if (sm) sm.textContent = plan ? (box.getAttribute('data-l-barre') || '').replace('__NOM__', cur.getAttribute('data-choix') || '') : u.small;
      }
      if (annoncer && cur) {
        var live = root.querySelector('[data-eg-var-live]');
        if (live) live.textContent = (box.getAttribute('data-l-annonce') || '').replace('__C__', cur.getAttribute('data-choix') || '').replace('__P__', cur.getAttribute('data-prix') || '');
      }
    }

    /* Galerie : flèches précédent / suivant et touches ← → (Début, Fin) quand la galerie ou une flèche a le focus.
       La photo courante se lit comme pour les points (eg-app.js) : arrondi de scrollLeft / largeur ; flèches et points
       suivent donc le même défilement. Pendant un défilement lancé ici, l'état vaut la photo visée (clics rapides cumulés).
       Mouvements réduits : défilement immédiat. Seul le conteneur .gal-track défile, jamais la page. */
    function gallery(root) {
      var gal = root.querySelector('.gal');
      var trk = gal && gal.querySelector('.gal-track');
      var prev = gal && gal.querySelector('[data-eg-gal="prev"]');
      var next = gal && gal.querySelector('[data-eg-gal="next"]');
      if (!trk || !prev || !next) return;
      var pos = gal.querySelector('[data-eg-gal-pos]');
      var n = trk.children.length;
      var goal = -1;
      var timer = 0;
      var raf = 0;
      var last = 0;
      var spoke = false;

      function cur() {
        var w = trk.clientWidth;
        return w ? Math.max(0, Math.min(n - 1, Math.round(trk.scrollLeft / w))) : 0;
      }
      function at() { return goal >= 0 ? goal : cur(); }
      function paint() {
        var i = at();
        prev.setAttribute('aria-disabled', String(i <= 0));
        next.setAttribute('aria-disabled', String(i >= n - 1));
        if (pos && spoke && i !== last) pos.textContent = (pos.getAttribute('data-l') || '').replace('%N', String(i + 1));
        last = i;
      }
      function settle() { goal = -1; clearTimeout(timer); paint(); }
      function go(i) {
        i = Math.max(0, Math.min(n - 1, i));
        spoke = true;
        if (i === at()) return;
        goal = i;
        trk.scrollTo({ left: i * trk.clientWidth, behavior: REDUCE ? 'auto' : 'smooth' });
        clearTimeout(timer);
        timer = setTimeout(settle, 900);
        paint();
      }

      gal.addEventListener('click', function (e) {
        var b = e.target.closest('[data-eg-gal]');
        if (!b || !gal.contains(b) || b.getAttribute('aria-disabled') === 'true') return;
        go(at() + (b.getAttribute('data-eg-gal') === 'prev' ? -1 : 1));
      });
      gal.addEventListener('keydown', function (e) {
        if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
        if (e.target !== trk && !(e.target.hasAttribute && e.target.hasAttribute('data-eg-gal'))) return;
        var k = e.key;
        var t = k === 'ArrowRight' ? at() + 1 : k === 'ArrowLeft' ? at() - 1 : k === 'Home' ? 0 : k === 'End' ? n - 1 : null;
        if (t === null) return;
        e.preventDefault();
        go(t);
      });
      trk.addEventListener('scroll', function () {
        if (goal >= 0 && Math.abs(trk.scrollLeft - goal * trk.clientWidth) < 2) { goal = -1; clearTimeout(timer); }
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; paint(); });
      }, { passive: true });
      trk.addEventListener('scrollend', settle);
      /* Geste de l'utilisateur (doigt, souris, pavé tactile) : la photo visée n'a plus cours, la position réelle reprend la main. */
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
        trk.addEventListener(ev, function () { if (goal >= 0) settle(); }, { passive: true });
      });
      if ('ResizeObserver' in window) new ResizeObserver(function () { if (goal < 0) paint(); }).observe(trk);
      paint();
    }

    /* Vus récemment (section eg-product-suite) : le produit courant passe en tête ; les 10 précédents sont affichés. */
    function initVus(sec) {
      if (!sec || sec.hasAttribute('data-eg-ready')) return;
      sec.setAttribute('data-eg-ready', '');
      var handle = sec.getAttribute('data-handle');
      var list = readVus().filter(function (h) { return h !== handle; });
      writeVus([handle].concat(list).slice(0, 12));
      var show = list.slice(0, 10);
      if (!show.length) return;
      function load() {
        Promise.all(show.map(function (h) {
          return fetch(rootUrl() + 'products/' + encodeURIComponent(h) + '?section_id=eg-product-carte', { headers: { Accept: 'text/html' } })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .catch(function () { return ''; });
        })).then(function (arr) {
          var html = '';
          arr.forEach(function (t) {
            if (!t) return;
            var c = parse(t).querySelector('.card');
            if (c) html += c.outerHTML;
          });
          if (!html || !sec.isConnected) return;
          sec.querySelector('.rail').innerHTML = html;
          sec.hidden = false;
        });
      }
      /* Chargement seulement à l'approche du rail (la section est masquée tant qu'elle est vide : on observe la rubrique qui la précède). */
      var mark = sec.previousElementSibling || sec.parentElement;
      if (!('IntersectionObserver' in window) || !mark) { setTimeout(load, 600); return; }
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (en) { return en.isIntersecting; })) return;
        io.disconnect();
        load();
      }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(mark);
    }

    /* « Donner mon avis » : ouvre le formulaire du widget Judge.me s'il est présent, sinon fait défiler jusqu'au widget. */
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-eg-review]');
      if (!b) return;
      e.preventDefault();
      var w = document.querySelector('[data-eg-apps] .jdgm-write-rev-link, [data-eg-apps] [data-jdgm-write-review]');
      if (w) w.click();
      /* Ce bouton n'est visible que si le widget n'a pas rendu son propre en-tête (voir #avis:has) : on amène le formulaire à l'écran. */
      var apps = document.querySelector('[data-eg-apps]');
      var form = apps && apps.querySelector('.jdgm-form-wrapper');
      var target = (form && form.offsetParent !== null) ? form : apps;
      if (target) setTimeout(function () { target.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'start' }); }, w ? 60 : 0);
    });

    function start() {
      document.querySelectorAll('[data-eg-product]').forEach(init);
      document.querySelectorAll('[data-eg-vus]').forEach(initVus);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target.querySelector('[data-eg-product]'));
      initVus(e.target.querySelector('[data-eg-vus]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-retractation"] && !Shopify.designMode) return;
  try {
    
  /* Rétractation (section eg-retractation) : étapes 1 et 2, composition du message, écran de confirmation. */
  (function () {
    var CLE = 'egRetractation';
    function fmt(d) {
      try {
        return new Intl.DateTimeFormat(document.documentElement.lang || undefined, { dateStyle: 'long', timeStyle: 'short' }).format(d);
      } catch (e) { return d.toLocaleString(); }
    }
    function dateLocale(v) {
      var p = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v || '');
      if (!p) return v;
      try {
        return new Intl.DateTimeFormat(document.documentElement.lang || undefined, { dateStyle: 'long' }).format(new Date(+p[1], +p[2] - 1, +p[3]));
      } catch (e) { return v; }
    }
    function remplirDl(dl, lignes) {
      dl.textContent = '';
      lignes.forEach(function (l) {
        var div = document.createElement('div');
        var dt = document.createElement('dt');
        var dd = document.createElement('dd');
        dt.textContent = l[0];
        dd.textContent = l[1];
        div.appendChild(dt);
        div.appendChild(dd);
        dl.appendChild(div);
      });
    }

    function confirmation(ok) {
      var data = null;
      try { data = JSON.parse(sessionStorage.getItem(CLE) || 'null'); } catch (e) { data = null; }
      if (data && data.lignes && data.quand && Date.now() - (data.ts || 0) < 7200000) {
        var q = ok.querySelector('[data-rt-quand]');
        q.textContent = String(q.getAttribute('data-modele')).replace('__D__', data.quand);
        ok.querySelector('[data-rt-ok-decl]').textContent = data.decl || '';
        remplirDl(ok.querySelector('[data-rt-ok-dl]'), data.lignes);
        ok.querySelector('[data-rt-ok-contenu]').hidden = false;
      }
      var pr = ok.querySelector('[data-rt-print]');
      if (pr) pr.addEventListener('click', function () { window.print(); });
      ok.focus();
    }

    function init(form) {
      var ok = form.querySelector('[data-rt-ok]');
      if (ok) { confirmation(ok); return; }
      var t = form.querySelector('[data-rt-t-requis]');
      var e1 = form.querySelector('[data-rt-etape="1"]');
      var e2 = form.querySelector('[data-rt-etape="2"]');
      if (!t || !e1 || !e2) return;
      var f = {
        nom: form.querySelector('#EgRtNom'),
        email: form.querySelector('#EgRtEmail'),
        cmd: form.querySelector('#EgRtCmd'),
        prod: form.querySelector('#EgRtProd'),
        recu: form.querySelector('#EgRtRecu')
      };
      var liste = form.querySelector('[data-rt-liste]');
      var radios = Array.prototype.slice.call(form.querySelectorAll('[data-rt-portee]'));
      function certains() { return radios.some(function (r) { return r.checked && r.value === 'certains'; }); }
      function majListe() { liste.hidden = !certains(); }
      radios.forEach(function (r) { r.addEventListener('change', majListe); });
      majListe();

      var q = new URLSearchParams(window.location.search);
      var pre = (q.get('commande') || '').replace(/[^\w#\-]/g, '').slice(0, 40);
      if (pre && f.cmd.value.trim() === '') f.cmd.value = pre;

      function erreur(champ, msg) {
        var p = document.getElementById(champ.id + 'Err');
        if (msg) { champ.setAttribute('aria-invalid', 'true'); } else { champ.removeAttribute('aria-invalid'); }
        if (p) { p.textContent = msg || ''; p.hidden = !msg; }
        return !msg;
      }
      function verifier() {
        var premier = null;
        function v(champ, msg) { if (!erreur(champ, msg) && !premier) premier = champ; }
        v(f.nom, f.nom.value.trim() ? '' : t.getAttribute('data-rt-t-requis'));
        var em = f.email.value.trim();
        v(f.email, !em ? t.getAttribute('data-rt-t-requis') : (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em) ? '' : t.getAttribute('data-rt-t-email')));
        v(f.cmd, f.cmd.value.trim() ? '' : t.getAttribute('data-rt-t-requis'));
        if (certains()) { v(f.prod, f.prod.value.trim() ? '' : t.getAttribute('data-rt-t-produits')); } else { erreur(f.prod, ''); }
        var max = f.recu.getAttribute('max');
        v(f.recu, (f.recu.value && max && f.recu.value > max) ? t.getAttribute('data-rt-t-date') : '');
        if (premier) premier.focus();
        return !premier;
      }
      function numero() { return f.cmd.value.trim().replace(/^#+/, ''); }
      function lignes() {
        var l = [
          [t.getAttribute('data-rt-l-nom'), f.nom.value.trim()],
          [t.getAttribute('data-rt-l-email'), f.email.value.trim()],
          [t.getAttribute('data-rt-l-commande'), '#' + numero()],
          [t.getAttribute('data-rt-l-produits'), certains() ? f.prod.value.trim() : t.getAttribute('data-rt-l-tout')]
        ];
        if (f.recu.value) l.push([t.getAttribute('data-rt-l-reception'), dateLocale(f.recu.value)]);
        return l;
      }

      form.querySelector('[data-rt-continuer]').addEventListener('click', function () {
        if (!verifier()) return;
        remplirDl(form.querySelector('[data-rt-dl]'), lignes());
        e1.hidden = true;
        e2.hidden = false;
        form.querySelector('#EgRtE2').focus();
      });
      form.querySelector('[data-rt-modifier]').addEventListener('click', function () {
        e2.hidden = true;
        e1.hidden = false;
        form.querySelector('#EgRtE1').focus();
      });

      form.addEventListener('submit', function (ev) {
        /* Seul « Confirmer la rétractation » envoie, et seulement depuis l'étape 2. */
        if (e2.hidden) { ev.preventDefault(); form.querySelector('[data-rt-continuer]').click(); return; }
        if (!verifier()) { ev.preventDefault(); return; }
        var maintenant = new Date();
        var quand = fmt(maintenant);
        var decl = form.querySelector('[data-rt-decl]').textContent.trim();
        var l = lignes();
        l.push([t.getAttribute('data-rt-l-date'), quand]);
        form.querySelector('[data-rt-h-produits]').value = certains() ? f.prod.value.trim() : t.getAttribute('data-rt-l-tout');
        form.querySelector('[data-rt-h-date]').value = quand + ' (' + maintenant.toISOString() + ')';
        /* Objet en français pour le marchand, quelle que soit la langue du client. */
        form.querySelector('[data-rt-h-sujet]').value = 'Rétractation – commande #' + numero();
        form.querySelector('[data-rt-h-body]').value = decl + '\n\n' + l.map(function (x) { return x[0] + ' : ' + x[1]; }).join('\n');
        try { sessionStorage.setItem(CLE, JSON.stringify({ ts: maintenant.getTime(), quand: quand, decl: decl, lignes: l })); } catch (e) { /* écran générique */ }
        var b = form.querySelector('[data-rt-confirmer]');
        if (b) b.setAttribute('aria-disabled', 'true');
      });
    }

    function start() { document.querySelectorAll('[data-eg-rt]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  } catch(e) { console.error(e); }
})();
})();
